import type {
  AgreeTermsRequestDTO,
  TermsDataSource,
} from '~/api/data-source/terms';
import { termsDataSource } from '~/api/data-source/terms';
import type { TermsResponse } from '~/api/model';
import { parseModel, termsResponseSchema } from '~/api/model';

// ============================================================================
// Terms Repository
// ============================================================================

export interface TermsRepository {
  /** 약관 조회 */
  getTerms(bundleId: string): Promise<TermsResponse>;
  /** 주소 등록 약관 조회 */
  getAddressTerms(): Promise<TermsResponse>;
  /** 약관 동의 */
  agreeTerms(request: AgreeTermsRequestDTO): Promise<void>;
}

export class TermsRepositoryImpl implements TermsRepository {
  // eslint-disable-next-line no-useless-constructor
  constructor(private readonly dataSource: TermsDataSource = termsDataSource) {}

  async getTerms(bundleId: string) {
    const response = await this.dataSource.getTerms(bundleId);
    return parseModel(termsResponseSchema, response, 'TermsResponse');
  }

  async getAddressTerms() {
    const response = await this.dataSource.getAddressTerms();
    return parseModel(termsResponseSchema, response, 'TermsResponse');
  }

  async agreeTerms(request: AgreeTermsRequestDTO) {
    return this.dataSource.agreeTerms(request);
  }
}

export const termsRepository = new TermsRepositoryImpl();
